import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";

// Components
import Dashboard from "./Dashboard";
import ForestDetail from "./ForestDetail";
import PlotDetail from "./PlotDetail";
import AuthPage from "./AuthPage";

// Styles
import "./App.css";

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
    <Router>
      <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<AuthPage />} />
            <Route path="/signup" element={<AuthPage />} />

            {/* Protected Routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            
            {/* Forest Detail Page - Shows forest overview and plots */}
            <Route path="/forest/:id" element={
              <ProtectedRoute>
                <ForestDetail />
              </ProtectedRoute>
            } />
            
            {/* Plot Detail Page - Shows specific plot/hectare details */}
            <Route path="/plot/:plotId" element={
              <ProtectedRoute>
                <PlotDetail />
              </ProtectedRoute>
            } />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}
